if (!customElements.get('card-color-swatches')) {
  /**
   *  @class
   *  @function CardColorSwatches
   */
  class CardColorSwatches extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cardImageOverlay = document.querySelector(`#${this.dataset.id} .card__image--overlay img`);
      this.actionButton = this.querySelector('.color-swatch--action');

      this.outSwatches = this.querySelectorAll('.color-swatch[data-swatch-out]');
      this.swatches = this.querySelectorAll('.color-swatch')

      if (this.actionButton)
        this.actionButton.addEventListener('click', this.onActionClick.bind(this));

      if (this.swatches.length > 0 && this.cardImageOverlay) {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('mouseover', this.onMouseOver.bind(this))
        })
      }
    }

    onActionClick() {
      if (this.classList.contains('expanded')) {

        this.outSwatches.forEach((swatch) => {
          swatch.classList.add('close-animation');
        })

        setTimeout(() => {
          this.outSwatches.forEach((swatch) => {
            swatch.classList.remove('close-animation');
          })
          this.classList.remove('expanded')
        }, 300)
      }
      else {

        this.outSwatches.forEach((swatch) => {
          swatch.classList.add('open-animation');
        })

        setTimeout(() => {
          this.outSwatches.forEach((swatch) => {
            swatch.classList.remove('open-animation');
          })
          this.classList.add('expanded')
        }, 300)
      }
    }
    onMouseOver({ currentTarget }) {
      if (!this.cardImageOverlay) return;
      requestAnimationFrame(() => {
        this.cardImageOverlay.src = currentTarget.getAttribute('data-swatch-image')
        this.cardImageOverlay.srcset = currentTarget.getAttribute('data-swatch-srcset')
      })

    }

  }

  customElements.define('card-color-swatches', CardColorSwatches)
}